import { useState } from 'react';
import { getGoogleAuthUrl } from 'api/auth/index';
import loadingGif from 'images/loader2.webp';
import { getTenantId } from 'utils/helper';

const GoogleAuthButton = ({ onError }) => {
  const [loading, setLoading] = useState(false);

  const handleGoogleLogin = async () => {
    setLoading(true);
    try {
      const tenantAppId = await getTenantId();
      
      const payload = {
        tenant: tenantAppId,
      };
      let authUrl = await getGoogleAuthUrl(payload);
      
      window.location.href = authUrl;
      setLoading(false);
    } catch (err) {
      setLoading(false);
      if (onError) onError(err?.response?.data ?? err);
    }
  };

  return (
    <button
      className="flex justify-center items-center gap-3 w-full p-3 mt-4 rounded bg-white text-black border border-gray-300 hover:bg-gray-100 disabled:opacity-50"
      onClick={handleGoogleLogin}
      disabled={loading}
      type="button"
    >
      {loading ? (
        <img src={loadingGif} alt="loading" className="h-6 w-6" />
      ) : (
        <img src="https://developers.google.com/identity/images/g-logo.png" alt="Google" className="h-6 w-6" />
      )}
      Continue with Google
    </button>
  );
};

export default GoogleAuthButton; 